// Список тарифных планов Подсказок.

import analytics from "../marketing/analytics";
import utils from "../utils";
import createComponent from "../vue";
import popupsState from "../popups/popups-state";

const { user } = window.DA;

function isLarge(planName) {
    return planName === "suggestions_large";
}

function initAnalytics() {
    analytics.reachGoalOnClick("#plans-view [data-ref=suggestions_small]", "SUGGESTIONS_SMALL");
    analytics.reachGoalOnClick("#plans-view [data-ref=suggestions_medium]", "SUGGESTIONS_MEDIUM");
    analytics.reachGoalOnClick("#plans-view [data-ref=suggestions_large]", "SUGGESTIONS_LARGE");
    analytics.reachGoalOnClick("#suggestions_registration_popup button", "SUGGESTIONS_SIGNUP_PAY");
}

const sugsVueConfig = {
    data() {
        return {
            plans: [],
            subscription: {},
            large_options: [],
            large_quantity: 0,
            has_free_plan: false,
            has_premium_plan: false,
            purchase_url: "",
            plan_name: "",
            price: "",
            is_loaded: false,
            submitting: false,
        };
    },
    mounted() {
        this.populate();
    },
    methods: {
        button_caption(plan) {
            let price;
            if (isLarge(plan.name)) {
                price = this.large_quantity * plan.price;
            } else {
                price = plan.price;
            }
            price = `${utils.formatMoney(price)}`;
            return `Купить за ${price} в год`;
        },

        async populate() {
            try {
                const res = await fetch("/subscriptions/get-plans/");
                const data = await res.json();
                this.show(data);
                this.$nextTick(initAnalytics);
            } catch (error) {
                console.log(error);
            }
        },

        show(data) {
            this.plans = data.plans;
            this.subscription = data.subscription || {};
            this.large_options = data.large_options;
            this.large_quantity = data.large_options[0].quantity;
            this.has_free_plan = data.has_free_plan;
            this.has_premium_plan = data.has_premium_plan;
            this.purchase_url = data.purchase_url;
            this.is_authenticated = user.isAuthenticated;
            this.is_loaded = true;
        },

        showPlanPopup(planName, price) {
            this.plan_name = planName;
            this.price = price;
            const quantity = isLarge(this.plan_name) ? this.large_quantity : 1;
            const amount = this.price * quantity;

            popupsState.dispatchOpen({
                newPopupId: "signup_payment_popup",
                popupData: {
                    amount,
                    quantity,
                    planName: this.plan_name,
                },
            });
        },

        // Переводит на страницу управления подпиской (для зарегистрированных)
        // либо стартует анонимную покупку
        on_purchase(planName, price) {
            if (this.is_authenticated) {
                const url = `${this.purchase_url}?plan=${planName}`;
                window.open(url, "_blank");
            } else {
                this.showPlanPopup(planName, price);
            }
        },
    },
};

createComponent(sugsVueConfig, "#plans-view");

export default {};
